export { AppProxy } from "./app-proxy";
